<template>
<div id="login">

  <div class="s-title">登录.</div>

  <!-- <div class="sub-title">输入手机号码</div> -->

  <div class="s-input-c phone">
    <input class="s-input" v-model="phoneValue" type="number" oninput="if(value.length > 11)value = value.slice(0, 11)" @blur="verification()" placeholder="请输入手机号" maxlength="11" />

    <div class="yzmbtn" v-if="vercodelogin" @click="getvercode" v-track="{ name: 'getvercode' }">{{yzmTxt}}</div>
  </div>

  <div class="s-input-c yzm" v-if="vercodelogin">
    <!-- <div class="">验证码</div> -->
    <input class="s-input" v-model="vercodeValue" type="number" placeholder="请输入验证码" maxlength="11" />
  </div>


  <div class="s-input-c yzm" v-if="!vercodelogin">
    <!-- <div class="">验证码</div> -->
    <input class="s-input" v-model="passwordValue" type="password" placeholder="请输入密码" />
  </div>

  <div class="handle">
    <div class="zc"></div>
    <div class="logintype" @click="vercodelogin = !vercodelogin" v-track="{ name: 'changeloginstate' }">{{vercodelogin?"账号密码登录":"验证码登录"}}</div>
  </div>

  <div class="sfinish" @click="login()"  v-track="{ name: 'login' }">
    <span v-if="!loading">立即登录</span>
    <van-loading v-if="loading" color="#fff" size="18" class="loading" type="spinner" />

  </div>


  <div class="c-xieyi" v-if="showpro">
    <!-- <div class="select" :class="{'agree':agree}" @click="loginchange"></div> -->
    <div>
      我已阅读并同意
      <span @click="gofwprotocol" v-track="{ name: 'gofwprotocol' }">《用户服务协议》</span>
      和
      <span @click="goysprotocol" v-track="{ name: 'goysprotocol' }">《隐私政策》</span>
    </div>
  </div>


</div>
</template>

<script>
import Toast from 'vant/lib/toast';
import "vant/lib/toast/style";
import Loading from 'vant/lib/loading';
import "vant/lib/loading/style";
import { host }  from "@/common/common.js"

import {
  api_sendSms,
  api_loginSms,
  api_loginPwd
} from "@/api"

export default {
  name: 'Sign',
  data() {
    return {
      phoneValue: null,
      vercodeValue: null,
      passwordValue: null,
      yzmTxt: "获取验证码",
      time: 60,
      vercodeToken: null,
      agree: false,
      vercodelogin: true,
      loading: false,
      showpro:true,
    }
  },
  methods: {

    gofwprotocol() {
      this.$router.push({
        path: '/h5',
        query: {
          title: '用户服务协议'
        }
      })
    },

    goysprotocol() {
      this.$router.push({
        path: '/h5',
        query: {
          title: '隐私政策'
        }
      })
    },

    getvercode() {
      if (!this.phoneReg(this.phoneValue)) {
        Toast({
          message: "请输入正确手机号",
          duration: 2000
        })
        return;
      }
      Toast({
        message: "验证码已发送",
        duration: 1000
      })
      this.startCountingDown();
      this.$track('click_login_sendsms')
      api_sendSms(this.phoneValue).then(res => {
        console.log("api_sendSms", res);
        this.vercodeToken = res.data.token;
      }).catch(error => console.log(error));

    },
    phoneReg(phone) {
      return /^1[0-9][0-9]\d{8}$/.test(phone)
    },
    loginchange() {
      this.agree = !this.agree;
      this.vercodeValue = null;
      this.passwordValue = null;
    },
    login() {

      if (this.loading) {
        return;
      }

      if (!this.phoneReg(this.phoneValue)) {
        Toast({
          message: "请输入正确手机号",
          duration: 2000
        })
        return;
      }

      if (!this.vercodeToken && this.vercodelogin) {
        Toast({
          message: "请获取验证码",
          duration: 2000
        })
        return;
      }

      if (!this.vercodeValue && this.vercodelogin) {
        Toast({
          message: "请输入验证码",
          duration: 2000
        })
        return;
      }

      if (!this.passwordValue && !this.vercodelogin) {
        Toast({
          message: "请输入密码",
          duration: 2000
        })
        return;
      }

      this.loading = true;

      if (this.vercodelogin) {
        this.$track('click_login_sms')
        //验证码登录
        api_loginSms(this.phoneValue,
          this.vercodeValue,
          this.vercodeToken,
          this.$store.state.openid).then(res => {
          this.$store.commit('cmtToken', res.data.token);
          this.goBack()
          this.loading = false;
        }).catch(ex => {
          console.log('api_loginSms ex', ex);
          this.loading = false;
        });
      } else {
        //密码登录
        this.$track('click_login_password')
        api_loginPwd(this.phoneValue,
          this.passwordValue,
          this.$store.state.openid).then(res => {
          this.$store.commit('cmtToken', res.data.token);
          this.goBack()
          this.loading = false;
        }).catch(ex => {
          console.log('api_loginPwd ex', ex);
          this.loading = false;
        });
      }


    },
    verification() {
      var re = /^1\d{10}$/;
      let str = this.phoneValue;
      if (re.test(str)) {
        console.log(str);
      } else {
        console.log(str);
      }
    },
    startCountingDown() {
      this.time -= 1
      if (this.time <= 0) {
        this.yzmTxt = '获取验证码'
        this.time = 60
      } else {
        this.yzmTxt = this.time + ' s'
        setTimeout(() => {
          this.startCountingDown()
        }, 1000);
      }
    },
    goBack() {
      let query = this.$route.query

      if (query.from) {
        let path = query.from
        delete query.from
        this.$router.replace({
          path: decodeURIComponent(path),
          query: query
        })
      } else {
        this.$router.back()
      }
    }
  },
  components: {
    'van-loading': Loading,
  },
  mounted() {
      var h = document.body.scrollHeight;
      window.onresize = ()=>{
         if (document.body.scrollHeight < h) {
           this.showpro = false;
        }else{
             this.showpro = true;
       }
      }
  },
  created() {
    this.$track('start_login')
    this.$store.dispatch("act_logout","");

    this.$store.dispatch('share/initShareParams', {
      title: '七天学堂学情查询',
      desc: '快来看看你的学情分析报告'
    })
  }
}
</script>

<style lang="scss">
#login {
    padding-left: 26px;
    padding-right: 26px;

    .s-title {
        font-size: 28px;
        margin-top: 65px;
        margin-bottom: 40px;
    }

    .sub-title {
        font-size: 15px;
        color: #c5c6c7;
        margin-top: 22px;
    }

    .s-input {
        border: none;
        font-size: 17px;
        color: #111;

    }

    .s-input::-webkit-input-placeholder {
        color: #c5c6c7;
    }

    .s-input-c {
        padding-top: 10px;
        padding-bottom: 15px;
        position: relative;
    }

    .s-input-c::after {
        height: 0.55px;
        content: "";
        width: 100%;
        background: #dadada !important;
        position: absolute;
        right: 0;
        -webkit-transform: scaleY(0.35);
        -ms-transform: scaleY(0.35);
        transform: scaleY(0.35);
        z-index: 99;
        bottom: 0;
    }

    .phone {
        margin-bottom: 25px;
    }

    .yzmbtn {
        position: absolute;
        right: 0;
        top: 11px;
        color: #000;
    }

    .handle {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
        font-size: 12px;
        .zc {
            width: 80px;
            height: 25px;
        }

        .logintype {
            width: 80px;
            height: 25px;
            text-align: right;
        }
    }

    .yzm {
        display: flex;
        // justify-content: space-between;
        font-size: 17px;
        margin-top: 15px;

        .s-input {
            //  margin-left: 15px;

        }
    }

    .sfinish {
        color: white;
        background: #ed5b68;
        width: 100%;
        height: 50px;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
        // margin-left: 5%;
    }

    .c-xieyi {
        position: absolute;
        bottom: 10px;
        display: flex;
        align-items: center;
        font-size: 13px;
        margin-top: 10px;
        color: #c5c6c7;
        .select {
            width: 14px;
            height: 14px;
            border-radius: 14px;
            border: 1px solid #c5c6c7;
            margin-right: 5px;
        }

        .agree {
            border: 1px solid #ed5b68;
            background: #ed5b68;
        }

        span {
            color: #5C94E4;
        }
    }

}
</style>
